/*
 *
 * ResetPassword constants
 *
 */

export const RESET_PASSWORD_CHANGE = 'src/ResetPassword/RESET_PASSWORD_CHANGE';
export const RESET_PASSWORD_RESET = 'src/ResetPassword/RESET_PASSWORD_RESET';
export const SET_RESET_PASSWORD_FORM_ERRORS = 'src/ResetPassword/SET_RESET_PASSWORD_FORM_ERRORS';
export const RESET_PASSWORD_TOKEN = 'src/ResetPassword/RESET_PASSWORD_TOKEN';
export const RESET_PWD_LOADING = 'src/ResetPassword/RESET_PWD_LOADING';
